export const ARCHIVE_CHECK_SUCCESS = 'ARCHIVE_CHECK_SUCCESS'
export const ARCHIVE_CHECK_FAIL = 'ARCHIVE_CHECK_FAIL'
export const ARCHIVE_JOBS_SUCCESS = "ARCHIVE_JOBS_SUCCESS";
export const ARCHIVE_JOBS_FAIL = "ARCHIVE_JOBS_FAIL";
export const ARCHIVE_REPORTS_SUCCESS = "ARCHIVE_REPORTS_SUCCESS";
export const ARCHIVE_REPORTS_FAIL = "ARCHIVE_REPORTS_FAIL";

export const defaultArchiveState = {
  archiveCounts: null,
  error: false,
  errorMessage: null,
};

export default (state = defaultArchiveState, action) => {
  switch (action.type) {
    case ARCHIVE_CHECK_SUCCESS:
      return {
        ...state,
        archiveCounts: action.payload.data,
      };
    case ARCHIVE_JOBS_SUCCESS: {
      return {
        ...state,
      };
    }
    case ARCHIVE_REPORTS_SUCCESS: {
      return {
        ...state,
      };
    }
    case ARCHIVE_CHECK_FAIL:
    case ARCHIVE_JOBS_FAIL:
    case ARCHIVE_REPORTS_FAIL:
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    default:
      return {
        ...state
      };
  }
}
